import { render, staticRenderFns } from "./EditStudyDetail.vue?vue&type=template&id=80f8404c&"
import script from "./EditStudyDetail.vue?vue&type=script&lang=js&"
export * from "./EditStudyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports